import React from 'react';
import { Instagram, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-black border-t border-[#d4af37]/20">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-['Playfair_Display'] text-3xl text-[#c9a961] mb-4">Balayage Vancouver</h3>
            <p className="text-[#f8f6f0]/60 text-sm leading-relaxed mb-4">
              Vancouver's premier destination for luxury balayage and hair coloring at Prép Beauty Parlour.
            </p>
            <div className="flex items-center space-x-4">
              <a
                data-testid="footer-instagram"
                href="https://www.instagram.com/prepbeautyparlour"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#c9a961]/10 flex items-center justify-center text-[#c9a961] hover:bg-[#c9a961] hover:text-black transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                data-testid="footer-tiktok"
                href="https://www.tiktok.com/@prepbeautyparlour"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#c9a961]/10 flex items-center justify-center text-[#c9a961] hover:bg-[#c9a961] hover:text-black transition-all duration-300"
                aria-label="TikTok"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"></path>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#f8f6f0] font-semibold mb-4 text-sm tracking-wide uppercase">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Gallery', 'FAQ'].map((item) => (
                <li key={item}>
                  <button
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-[#f8f6f0]/60 hover:text-[#c9a961] transition-colors text-sm"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#f5f5f0] font-semibold mb-4 text-sm tracking-wide uppercase">Services</h4>
            <ul className="space-y-3 text-[#f5f5f0]/60 text-sm">
              <li>Balayage</li>
              <li>Hair Coloring</li>
              <li>Highlights</li>
              <li>Color Correction</li>
              <li>Toning</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#f8f6f0] font-semibold mb-4 text-sm tracking-wide uppercase">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="text-[#c9a961] flex-shrink-0 mt-1" size={16} />
                <span className="text-[#f8f6f0]/60 text-sm">1305 Burrard St, Vancouver, BC V6Z 1Z7</span>
              </li>
              <li>
                <a
                  data-testid="footer-instagram-link"
                  href="https://www.instagram.com/prepbeautyparlour"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c9a961] hover:text-[#d4af37] transition-colors text-sm"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-tiktok-link"
                  href="https://www.tiktok.com/@prepbeautyparlour"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c9a961] hover:text-[#d4af37] transition-colors text-sm"
                >
                  TikTok
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-classpass-link"
                  href="https://classpass.com/studios/prp-beauty-parlour-vancouver"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c9a961] hover:text-[#d4af37] transition-colors text-sm"
                >
                  Book on ClassPass
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#d4af37]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#f5f5f0]/40 text-sm">
              © {currentYear} Balayage Vancouver - Prép Beauty Parlour. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <button
                data-testid="footer-book-cta"
                onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
                className="text-[#d4af37] hover:text-[#b8941f] transition-colors text-sm font-medium"
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
